import { getTelegramWebApp } from "../helpers/telegram";
import { NAME_SPACE } from "../../state/config";
import {
    normalizeLocale,
    resolveSupportedLocale,
    type SupportedLocale,
} from "./locales";

export const LOCALE_STORAGE_KEY = NAME_SPACE + "locale";
export const PENDING_LOCALE_STORAGE_KEY = NAME_SPACE + "locale-pending";

function readStorage(key: string): string | null {
    try {
        return window.localStorage.getItem(key);
    } catch {
        return null;
    }
}

function writeStorage(key: string, value: string): void {
    try {
        window.localStorage.setItem(key, value);
    } catch {
        // Locale persistence is best-effort when storage is unavailable.
    }
}

function removeStorage(key: string): void {
    try {
        window.localStorage.removeItem(key);
    } catch {
        // See writeStorage.
    }
}

export function getStoredLocale(): SupportedLocale | null {
    return normalizeLocale(readStorage(LOCALE_STORAGE_KEY));
}

export function storeLocale(locale: SupportedLocale): void {
    writeStorage(LOCALE_STORAGE_KEY, locale);
}

export function getPendingLocale(): SupportedLocale | null {
    return normalizeLocale(readStorage(PENDING_LOCALE_STORAGE_KEY));
}

export function storePendingLocale(locale: SupportedLocale): void {
    writeStorage(PENDING_LOCALE_STORAGE_KEY, locale);
}

export function clearPendingLocale(): void {
    removeStorage(PENDING_LOCALE_STORAGE_KEY);
}

export function detectInitialLocale(): SupportedLocale {
    const telegramLocale =
        getTelegramWebApp()?.initDataUnsafe.user?.language_code;
    const browserLocales =
        typeof navigator === "undefined"
            ? []
            : [navigator.language, ...navigator.languages];

    return resolveSupportedLocale(
        getStoredLocale(),
        telegramLocale,
        ...browserLocales,
    );
}
